import { Injectable } from '@angular/core';
import { ConfigService } from '../../data-services/config.service';

import { LoggingService } from '../logging.service';

@Injectable()
export class LanguageGuardService  {

  constructor(private loggingService: LoggingService,
              private configService: ConfigService) {
  }

  /**
   * Temporary fix so that a page refresh does not break the whole system
   * @returns {Promise<T>}
   */
  public canActivate(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // Making sure we are also loading the required data together with the user
      const dataFetch: Promise<any>[] = [];
      dataFetch.push(this.configService.retrieveLanguagePairs());

      // When all the data finishes loading async
      Promise.all(dataFetch)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          console.error('Failed to load session instance (language)');
          reject(false);
        });
    });
  }
}

